import type React from "react";
import { useMemo } from "react";

import { SearchOverviewTexts } from "../../texts";
import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import useOrganicPaidDataTable from "./hooks/useOrganicPaidDataTable";
import { getOrganicPaidTrafficColumns } from "./tableColumns";

const OrganicPaidTable: React.FC = () => {
    const { data, isLoading, isLoadingOrganicKeywords, isLoadingPaidKeywords } = useOrganicPaidDataTable();
    const columnConfig = useMemo(
        () =>
            data.length > 0 && !isLoading
                ? getOrganicPaidTrafficColumns({ isLoadingOrganicKeywords, isLoadingPaidKeywords })
                : [],
        [data, isLoading, isLoadingOrganicKeywords, isLoadingPaidKeywords],
    );

    return (
        <GenericWidgetTable
            data-automation="search-overview-organic-paid-table"
            tableProps={{ data, isLoading, columnConfig, bordersConfig: { body: true, groupBorder: true } }}
            title={SearchOverviewTexts.organicVsPaid}
            tooltip={"analysis.source.search.overview.widgets.search.tooltip"}
        />
    );
};

export default OrganicPaidTable;
